/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DomainStatusDto } from '../models/DomainStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DomainStatusControllerService {

    /**
     * Check status of a domain
     * @param name
     * @param port
     * @returns DomainStatusDto OK
     * @throws ApiError
     */
    public static getDomainHealthStatus(
        name: string,
        port: number = 5019,
    ): CancelablePromise<DomainStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/domains/{name}/status',
            path: {
                'name': name,
            },
            query: {
                'port': port,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
